import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import * as React from 'react';
import { AssetCarrierViewModel } from 'TypeGen/Assets/Carriers/List/asset-carrier-view-model';
import { fetchApi } from '../../services/api';
import { SelectedCarrierValue } from './CarrierGrid';

interface Props {
  SelectedCarrier: SelectedCarrierValue,
  CarrierValues: AssetCarrierViewModel[],
  CloseDialog: () => void;
}

interface State {
  isLoading: boolean;
  selectAll: boolean;
  vehicleTypes: number[];
}

export class CarrierSupportedVehiclesDialog extends React.Component<Props, State> {

  private vehicleTypes = [
    { value: 1, text: 'CARGO VAN', details: ['96 x 48 x 48 in.', '2,000 lbs. 55 mph'] },
    { value: 15, text: 'SPRINTER', details: ['96 x 48 x 70 in.', '3,000 lbs. 55 mph'] },
    { value: 2, text: 'SMALL STRAIGHT', details: ['216 x 84 x 84 in.', '10,000 lbs. 55 mph'] },
    { value: 3, text: 'LARGE STRAIGHT', details: ['288 x 96 x 96 in.', '14,000 lbs. 50 mph'] },
    { value: 4, text: 'TRACTOR', details: ['636 x 102 x 110 in.', '44,000 lbs. 50 mph'] },
    { value: 5, text: 'FLAT BED', details: ['636 x 102 x 102 in.', '47,000 lbs. 45 mph'] },
    { value: 6, text: 'AIR FREIGHT', details: ['636 x 102 x 110 in.', '50,000 lbs. 500 mph'] },
    { value: 7, text: 'REEFER', details: ['636 x 102 x 110 in.', '50,000 lbs. 45 mph'] },
    { value: 8, text: 'SPECIALIZED', details: ['636 x 102 x 110 in.', '50,000 lbs. 45 mph'] },
    { value: 9, text: 'FLATBED CURTAIN', details: ['636 x 102 x 102 in.', '44,000 lbs. 45 mph'] },
    { value: 10, text: 'FLATBED W/TARPS', details: ['576 x 102 x 102 in.', '47,000 lbs. 45 mph'] },
    { value: 11, text: 'STEP CURTAIN', details: ['636 x 102 x 118 in.', '43,000 lbs. 45 mph'] },
    { value: 12, text: 'OPEN STEP', details: ['636 x 102 x 122 in.', '47,000 lbs. 45 mph'] },
    { value: 13, text: 'OVERSIZE FLAT', details: ['636 x 102 x 102 in.', '47,000 lbs. 45 mph'] },
    { value: 14, text: 'OVERSIZE STEP', details: ['636 x 102 x 122 in.', '47,000 lbs. 45 mph'] },
    { value: 17, text: 'DOUBLE DROP RGN', details: ['636 x 102 x 138 in.', '38,000 lbs. 45 mph'] },
    { value: 18, text: 'FLAT OR STEP RETRACTABLE', details: ['636 x 102 x 110 in.', '44,000 lbs. 45 mph'] },
    { value: 19, text: 'DOUBLE DROP CURTAINSIDE', details: ['636 x 102 x 138 in.', '38,000 lbs. 45 mph'] },
    { value: 20, text: 'AIR CHARTER', details: ['45 mph'] },
    { value: 21, text: 'CONTAINER', details: ['102 x 40 x 40 in.', '40,000 lbs. 45 mph'] },
    { value: 22, text: 'LTL', details: ['45 mph'] },
    { value: 23, text: 'HOTSHOT', details: ['40 x 96 x 0 in.', '16,500 lbs. 45 mph'] },
    { value: 24, text: 'HAND CARRY', details: ['636 x 102 x 110 in.', '50,000 lbs. 500 mph'] }
  ];

  constructor(props: Props) {
    super(props);

    this.state = {
      isLoading: false,
      selectAll: false,
      vehicleTypes: []
    }

    this.getCarrierVehicleTypes = this.getCarrierVehicleTypes.bind(this);
    this.updateCarrierVehicleTypes = this.updateCarrierVehicleTypes.bind(this);
    this.isVehicleChecked = this.isVehicleChecked.bind(this);
    this.vehicleTypeOnChange = this.vehicleTypeOnChange.bind(this);
  }

  public componentDidMount() {
    this.getCarrierVehicleTypes();
  }

  public render() {
    return (
      <Dialog title="Supported Vehicle Types" onClose={this.props.CloseDialog} className="dialog-w1140">
        <div className="container">
          <label className="checkbox-inline mb-4" style={{ fontSize: "14px", cursor: "pointer" }} >
            <input type="checkbox" style={{ verticalAlign: "middle", cursor: "pointer" }}
              checked={this.state.selectAll} onChange={(e: any) => {
                if (this.state.selectAll === false)
                  this.setState({ vehicleTypes: this.vehicleTypes.map((vehicle) => vehicle.value) });
                else
                  this.setState({ vehicleTypes: [] });

                this.setState({ selectAll: !this.state.selectAll });
              }} />
            &nbsp;SELECT ALL
          </label>
          <div className="row">
            {this.vehicleTypes.map((vehicle) => this.cellBuilder(vehicle))}
          </div>
        </div>
        <DialogActionsBar layout="end">
          <Button onClick={this.props.CloseDialog}>Cancel</Button>
          <Button themeColor="primary" onClick={this.updateCarrierVehicleTypes}>Save</Button>
        </DialogActionsBar>
      </Dialog>
    );
  }

  private isVehicleChecked(vehicle: any): boolean {
    return this.state.vehicleTypes.indexOf(vehicle.value) > -1
  }

  private vehicleTypeOnChange(e: any, vehicle: any) {
    const vehTypes = this.state.vehicleTypes;
    if (!e.target.checked)
      vehTypes.splice(vehTypes.indexOf(vehicle.value), 1);
    else
      vehTypes.push(vehicle.value);
    this.setState({ vehicleTypes: vehTypes });
  }

  private cellBuilder(vehicle: any): JSX.Element {
    return <div className="col-3 mb-3" key={vehicle.value}>
      <label className="checkbox-inline mb-0" style={{ fontSize: "14px", cursor: "pointer" }} >
        <input type="checkbox" style={{ verticalAlign: "middle", cursor: "pointer" }} checked={this.isVehicleChecked(vehicle)} onChange={(e: any) => {
          this.vehicleTypeOnChange(e, vehicle);
        }} />
        &nbsp;{vehicle.text}
      </label>
      <div className="text-muted" style={{ fontSize: "12px", paddingLeft: "20px", whiteSpace: "nowrap" }}>
        {vehicle.details.map((detail: string) => <div key={detail}>{detail}</div>)}
      </div>
    </div>
  }

  private getCarrierVehicleTypes() {
    this.setState({ isLoading: true });

    const carrierPhone = this.props.CarrierValues.filter(x => x.CarrierID === this.props.SelectedCarrier.CarrierID)[0].Phone1.replace(/\D/g, '').slice(-10);

    fetchApi(`/api/Asset/GetCarrierVehicleTypes/${carrierPhone}`)
      .then((response) => {
        this.setState({
          vehicleTypes: response.length > 0 ? response : this.vehicleTypes.map((vehicle) => vehicle.value),
          selectAll: response.length === this.vehicleTypes.length || response.length === 0,
          isLoading: false
        });
      });
  }

  private updateCarrierVehicleTypes() {
    this.setState({ isLoading: true });

    const carrierPhone = this.props.CarrierValues.filter(x => x.CarrierID === this.props.SelectedCarrier.CarrierID)[0].Phone1.replace(/\D/g, '').slice(-10);

    const data = {
      VehicleTypes: this.state.vehicleTypes
    };

    fetchApi(`/api/Asset/UpdateCarrierVehicleTypes/${carrierPhone}`, data, 'POST')
      .then(() => {
        this.setState({ isLoading: false }, () => {
          this.props.CloseDialog();
        })
      });
  }
}
